module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Da-Fb-Gb-Hc-Ia-outside.db04989e.png";